import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import type {
  ShipmentExceptionFeedback,
  ShipmentExceptionRow,
} from '../shipment-exception-types';

export type PostAccountExceptionClosedVariables = {
  accountId: number;
  exceptionId: number;
  feedback?: ShipmentExceptionFeedback | null;
  note?: string | null;
  shipmentId?: number;
};

export default function usePostAccountExceptionClosed() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      exceptionId,
      feedback,
      note,
    }: PostAccountExceptionClosedVariables): Promise<ShipmentExceptionRow> => {
      const { api, baseURL } = getApi();
      const body: Record<string, unknown> = {};
      if (feedback != null) body.feedback = feedback;
      if (note != null && note !== '') body.note = note;
      const res = await api.post(
        `/api/v2/accounts/${accountId}/exceptions/${exceptionId}/closed`,
        body,
        { baseURL },
      );
      return (res.data?.data ?? res.data) as ShipmentExceptionRow;
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['account-exceptions', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-exception-metrics', variables.accountId],
      });
      if (variables.shipmentId) {
        queryClient.invalidateQueries({
          queryKey: [
            'account-shipment-exceptions',
            variables.accountId,
            variables.shipmentId,
          ],
        });
      } else {
        queryClient.invalidateQueries({
          queryKey: ['account-shipment-exceptions', variables.accountId],
        });
      }
      queryClient.invalidateQueries({
        queryKey: ['account-shipments', variables.accountId],
      });
    },
  });
}
